module.exports = __webpack_public_path__ + "img/declarations_filled.cc7a3b7c.svg";